<template>
  <PasswordResetForm class="page-password-reset card-body" />
</template>

<script>

export default {
  name: 'page-password-reset',
  components: {
    PasswordResetForm: () => import('../../components/Account/PasswordResetForm'),
  },
  mounted () {
    this.$emit('title', 'Reset Password');
  },
};

</script>
